/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * RAIN_SNOW = auto()      # 눈/비  TEMP = auto()           # 온도  HUMIDITY = auto()       # 습도  DISCOMFORT = auto()     # 불쾌지수
 * @export
 * @enum {string}
 */

export enum WeatherType {
    Rain = 'rain',
    Temp = 'temp',
    Humidity = 'humidity',
    Discomfort = 'discomfort',
    Snow = 'snow',
}
